import { render, staticRenderFns } from "./activity-issues.vue?vue&type=template&id=1967e036&scoped=true"
import script from "./activity-issues.vue?vue&type=script&lang=js"
export * from "./activity-issues.vue?vue&type=script&lang=js"
import style0 from "./activity-issues.vue?vue&type=style&index=0&id=1967e036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1967e036",
  null
  
)

export default component.exports